import { registerComponent as S } from "@aileron/icon";
import { unsafeCSS as C, LitElement as $, nothing as w } from "lit";
import { html as f, unsafeStatic as L } from "lit/static-html.js";
import { property as h, query as _ } from "lit/decorators.js";
import { ifDefined as b } from "lit/directives/if-defined.js";
import { classMap as y } from "lit/directives/class-map.js";
const z = (i) => {
  class e extends i {
    constructor(...a) {
      super(...a), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const t = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(t.getElementsByTagName("link")).findIndex(
        (l) => l.href === this.fontLink
      ) === -1) {
        const l = document.createElement("link");
        l.href = this.fontLink, l.rel = "stylesheet", document.head.appendChild(l);
      }
    }
  }
  return e;
}, T = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.static{position:static}.inline{display:inline}.table{display:table}.hidden{display:none}[hidden]{display:none!important}', N = C(T), u = "aileron-color-scheme", v = "aileron-color-scheme-change", A = (i) => {
  const r = class r extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (t) => {
        t.detail ? this.setAttribute(u, t.detail) : this.removeAttribute(u);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        v,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const t = document.documentElement.getAttribute(
        u
      );
      t && this.setAttribute(u, t);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        v,
        this.handleSchemeSwitch
      );
    }
  };
  r.styles = [
    N,
    i.styles ?? []
  ];
  let e = r;
  return e;
}, E = A(z($)), I = ".aileron-link{font-family:AmericanSans Var;font-size:16px;font-weight:400;line-height:24px;text-transform:none;color:#006dc0;text-decoration:underline;padding-left:2px;padding-right:2px;display:inline-flex;align-items:center}.aileron-link:hover{text-decoration:none}.aileron-link:hover.aileron-link--with-icon,.aileron-link:hover.aileron-link--disabled{text-decoration:underline}.aileron-link:focus,.aileron-link:focus-visible{outline:2px solid #006DC0;border-radius:4px;border:0}.aileron-link:focus.aileron-link--inverse,.aileron-link:focus-visible.aileron-link--inverse{outline:2px solid #3AABFF}.aileron-link:focus.aileron-link--disabled,.aileron-link:focus-visible.aileron-link--disabled{outline:0}.aileron-link:visited{color:#5e6d7a;text-decoration-color:#5e6d7a}.aileron-link:visited.aileron-link--inverse{color:#9da6ab;text-decoration-color:#9da6ab}.aileron-link:visited .aileron-link__icon{color:#5e6d7a}.aileron-link:visited.aileron-link--disabled{color:#d0dae0;text-decoration-color:#d0dae0}.aileron-link:visited.aileron-link--inverse{color:#3aabff;text-decoration-color:#3aabff}.aileron-link:visited.aileron-link--inverse.aileron-link--disabled{color:#4d5e6c;text-decoration-color:#4d5e6c}.aileron-link--with-icon{text-decoration:none}.aileron-link__screen-reader{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px)}.aileron-link__icon{color:#006dc0;margin:4px}.aileron-link__icon:first-child,.aileron-link__icon:-moz-first-node{margin-left:0}.aileron-link__icon:last-child,.aileron-link__icon:-moz-last-node{margin-right:0}.aileron-link--inverse{color:#3aabff;text-decoration-color:#3aabff}.aileron-link--inverse.aileron-link--disabled{color:#4d5e6c;text-decoration-color:#4d5e6c}.aileron-link--disabled{color:#d0dae0;text-decoration-color:#d0dae0;cursor:not-allowed}";
function O(i, e) {
  const r = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (a, t) => {
    const { update: p } = a;
    if (i in a) {
      const d = i;
      a.update = function(l) {
        if (l.has(d)) {
          const k = l.get(d), x = this[d];
          k !== x && (!r.waitUntilFirstUpdate || this.hasUpdated) && this[t](
            k,
            x
          );
        }
        p.call(this, l);
      };
    }
  };
}
var R = Object.defineProperty, F = Object.getOwnPropertyDescriptor, s = (i, e, r, a) => {
  for (var t = a > 1 ? void 0 : a ? F(e, r) : e, p = i.length - 1, d; p >= 0; p--)
    (d = i[p]) && (t = (a ? d(e, r, t) : d(t)) || t);
  return a && t && R(e, r, t), t;
};
const m = "aileron-link", c = {
  root: m,
  screenReader: `${m}__screen-reader`,
  icon: `${m}__icon`,
  withIcon: `${m}--with-icon`,
  inverse: `${m}--inverse`,
  disabled: `${m}--disabled`
}, n = {
  NEWWINDOW: "new-window",
  CHEVRONRIGHT: "chevron-right",
  CHEVRON: "chevron",
  CHEVRONLEFT: "chevron-left",
  SIGNAL: "information",
  ARROW: "arrow-single-down",
  EMPTY: ""
}, g = class g extends E {
  constructor(e) {
    super(), this.icon = n.EMPTY, this.href = "", this.hiddenLabelText = "", this.inline = !1, this.white = !1, this.customElementString = e;
  }
  handleIconChanged() {
    this.icon === n.CHEVRON && console.warn(
      `Deprecation warning - [adc-link]: "icon='chevron'" is deprecated and will be removed in the next major release. Please use "icon='chevron-right'" instead`
    ), this.icon === n.SIGNAL && console.warn(
      `Deprecation warning - [adc-link]: "icon='information'" is deprecated and will be removed in the next major release.`
    ), this.icon === n.ARROW && console.warn(
      `Deprecation warning - [adc-link]: "icon='arrow-single-down'" is deprecated and will be removed in the next major release.`
    );
  }
  renderIcon() {
    const e = this.icon === n.SIGNAL ? "signal" : "navigation";
    return f`
        <${this.createTagName("-link-icon")}
          class="${c.icon}"
          exportparts="icon"
          icon='${e}:${this.icon === n.CHEVRON ? "chevron-right" : this.icon}'
        ></${this.createTagName("-link-icon")}>
    `;
  }
  render() {
    return this.disabled ? f`<span
        class=${y({
      [c.root]: !0,
      [c.disabled]: !0,
      [c.withIcon]: this.icon !== n.EMPTY
    })}
        part="anchor"
        rel=${b(this.rel)}
        aria-disabled="${this.disabled}"
      >
        ${this.icon === n.CHEVRONLEFT ? this.renderIcon() : w}
        <slot></slot>
        ${this.hiddenLabelText ? f`<span class="${c.screenReader}"
              >${this.hiddenLabelText}</span
            >` : w}
        ${this.icon !== n.CHEVRONLEFT && this.icon !== n.EMPTY ? this.renderIcon() : w}
      </span>` : f`
      <a
        class=${y({
      [c.root]: !0,
      [c.withIcon]: this.icon !== n.EMPTY
    })}
        href=${this.href}
        part="anchor"
        rel=${b(this.rel)}
        target=${b(this.target)}
      >
        ${this.icon === n.CHEVRONLEFT ? this.renderIcon() : w}
        <slot></slot>
        ${this.hiddenLabelText ? f`<span class="${c.screenReader}"
              >${this.hiddenLabelText}</span
            >` : w}
        ${this.icon !== n.CHEVRONLEFT && this.icon !== n.EMPTY ? this.renderIcon() : w}
      </a>
    `;
  }
  /**
   * Determine if a link is external or not
   * @private
   * @param href
   * @returns boolean
   */
  handleExternalHref(e) {
    return !!e.match(/^https?:\/\/(?!www.aa.com|aa.com)+/);
  }
  /**
   * If there is an external link, add a target="_blank" and rel="noopener
   * noreferrer"
   */
  connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-link"), S(
      this.customElementString ? this.customElementString + "-link" : "adc-link"
    ), this.href && this.handleExternalHref(this.href) && !this.target && (this.target = "_blank", this.rel = "noreferrer");
  }
  createTagName(e) {
    return L(
      this.customElementString ? this.customElementString + e : "adc" + e
    );
  }
};
g.styles = [E.styles || [], C(I)];
let o = g;
s([
  h({ reflect: !0 })
], o.prototype, "icon", 2);
s([
  h()
], o.prototype, "href", 2);
s([
  h({ reflect: !0, attribute: "hidden-label-text" })
], o.prototype, "hiddenLabelText", 2);
s([
  h({ reflect: !1 })
], o.prototype, "rel", 2);
s([
  h({ reflect: !1, type: Boolean })
], o.prototype, "disabled", 2);
s([
  h({ reflect: !1 })
], o.prototype, "target", 2);
s([
  h({ type: Boolean, reflect: !0 })
], o.prototype, "inline", 2);
s([
  h({ type: Boolean, reflect: !0 })
], o.prototype, "white", 2);
s([
  _(`.${c.root}`)
], o.prototype, "root", 2);
s([
  O("icon")
], o.prototype, "handleIconChanged", 1);
try {
  customElements.define("adc-link", o), console.warn("@aileron/link is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/link");
} catch {
}
function H(i) {
  try {
    customElements.define(
      `${i}-link`,
      class extends o {
        constructor() {
          super(i);
        }
      }
    );
  } catch {
  }
}
function Y(i) {
  try {
    H(i);
  } catch {
  }
}
export {
  n as ICON_KIND,
  o as Link,
  Y as registerComponent,
  H as registerLink
};
